import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { withStyles } from '@material-ui/core/styles';
import { ReactComponent as Download } from '../../res/download.svg';
import PdfLoader from '../../utils/PdfLoader';
import ButtonWithIcon from '../../components/ButtonWithIcon';

import styles from './styles';

class B1Home extends React.Component {
  renderBackground() {
    const { classes } = this.props;
    return (
      <div className={classes.background}>
        <div className={classes.bgImg}></div>
      </div>
    );
  }

  renderContent() {
    const { classes, data, baseUrl } = this.props;
    const baseUrlB1 = `${baseUrl}/blocks/`;
    return (
      <div className={classes.content}>
        <div className={classes.column}>
          <img src={`${baseUrlB1}${data.blocks.b1home.imgLogoSrc}`} alt="" className={classes.logo} />
          <div className={classes.btn}>
            <ButtonWithIcon
              onClick={PdfLoader(data.blocks.b1home.pdf)}
              color="black"
              icon={<Download />}
              iconPosition="top"
            >
              {parse(data.blocks.b1home.downloadBtn)}
            </ButtonWithIcon>
          </div>
        </div>
        <div className={classes.main}>
          <img src={`${baseUrlB1}${data.blocks.b1home.imgMainSrc}`} alt="" />
        </div>
      </div>
    );
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.blockContainer}>
        {this.renderBackground()}
        {this.renderContent()}
      </div>
    );
  }
}

B1Home.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object,
  baseUrl: PropTypes.string,
};

export default withStyles(styles)(B1Home);
